import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBS: CultureInfo = {
  name: 'en-BS',
  displayName: 'English (Bahamas)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BS',
  parent: CultureInfoEn
};
